export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  CURRENT_USER: "/auth/me",
  USERS: "/sys/users",
  BOTS: "/bots/bots",
  CALLBACK: "/callback",
};

export const BOT_TYPES = {
  LINE: "LINE",
  TELEGRAM: "TELEGRAM",
};

export const PERMISSIONS = {
  USER_MANAGE: "user_manage",
  BOT_MANAGE: "bot_manage",
  ADMIN: "admin",
};

export const SYS_CONFIG = {
  VERSION: "v1.0.2025030201",
};
